import { render } from "./Konsultasi.vue?vue&type=template&id=2d2c8ce2"
import script from "./Konsultasi.vue?vue&type=script&lang=js"
export * from "./Konsultasi.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/production/app.labparahita.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__